<template>
  <div class="condition-container">
    <b class="condition">{{ title }}</b>
    <div class="condition-items-container">
      <div class="condition-item">
        <div
          class="button-container"
          v-for="(item, index) in items"
          :key="index"
          @click="toggle(index)"
        >
          <img
            v-if="item.isSelected"
            class="check-icon"
            alt=""
            src="../../assets/check-2.svg"
          />
          <div class="button-text">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="filters-text-container">
    <img class="separator-icon" alt="" src="../../assets/separator.svg" />
  </div>
</template>

<script setup>
import { defineEmits } from "vue";

defineProps({
  title: String,
  items: Array,
});

const emits = defineEmits(["toggle"]);

function toggle(index) {
  emits("toggle", index);
}
</script>

<style scoped>
.condition-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: 10px;

  .condition {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 24px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    min-width: 80px;
  }

  .condition-items-container {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: var(--gap-3xs);

    .condition-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      gap: var(--gap-3xs);
      flex-wrap: wrap;

      .button-container {
        height: 33px;
        border-radius: var(--br-9xs);
        background-color: var(--white-default);
        border: 0.5px solid var(--primary-accent-base);
        box-sizing: border-box;
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: var(--padding-10xs) var(--padding-sm) var(--padding-10xs)
          var(--padding-4xs);
        gap: var(--gap-3xs);
        cursor: pointer;

        .check-icon {
          height: 16px;
          width: 16px;
          position: relative;
        }

        .button-text {
          position: relative;
          letter-spacing: 0.01em;
          line-height: 27px;
          font-weight: 600;
          display: inline-block;
          font-size: 16px;
          text-align: left;
        }
      }
    }
  }
}

.filters-text-container {
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  gap: var(--gap-xl);

  .filters {
    position: relative;
    letter-spacing: 0.02em;
    line-height: 27px;
    display: inline-block;
    min-width: 54px;
    font-weight: 700;
    text-align: left;
    color: #3b3b3b;
    font-size: 18px;
  }

  .separator-icon {
    align-self: stretch;
    position: relative;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    flex-shrink: 0;
  }
}
</style>
